/* eslint-disable @typescript-eslint/no-unsafe-call */
// ANCHOR React
import { memo } from 'react';

// ANCHOR Next
import dynamic from 'next/dynamic';

// ANCHOR Utils
import { ucarecdnScaleCropOptimize } from '@lyon/utils/ucarecdn';

// ANCHOR Components
import { ContentPoster } from '@lyon/components/utils/ContentPoster';
import { LionVideoPlayerInvalid } from './LionVideoPlayerInvalid';

const LionVideoPlyrCloudflare = dynamic(
  async () => {
    const mod = await import('./LionVideoPlyr');
    return mod.LionVideoPlyrCloudflare;
  },
  {
    ssr: false,
  },
);

const LionVideoPlyrBunny = dynamic(
  async () => {
    const mod = await import('./LionVideoPlyr');
    return mod.LionVideoPlyrBunny;
  },
  {
    ssr: false,
  },
);

const LionVideoPlyrLink = dynamic(
  async () => {
    const mod = await import('./LionVideoPlyr/LionPlyrLink');
    return mod.LionPlyrLink;
  },
  {
    ssr: false,
  },
);

const LionVideoPlyrLyon = dynamic(
  async () => {
    const mod = await import('./LionVideoPlyr');
    return mod.LionVideoPlyrLyon;
  },
  {
    ssr: false,
  },
);

interface IContentProps {
  videoId: string;
  posterId?: string;
  autoplay?: boolean;
  muted?: boolean;
}

const LionVideoPlayerContent = memo(({
  posterId,
  videoId,
  autoplay,
  muted,
}: IContentProps) => {
  const isURL = videoId.includes('https');
  const isCloudflare = videoId.length === 32;
  const isBunny = videoId.length === 36;
  const isLyon = videoId.length === 38 || videoId.startsWith('L-');

  if (isURL) {
    return (
      <LionVideoPlyrLink
        videoId={videoId}
        autoplay={autoplay}
        muted={muted}
      />
    );
  }

  if (isCloudflare) {
    return (
      <LionVideoPlyrCloudflare
        videoId={videoId}
        autoplay={autoplay}
        muted={muted}
        posterId={posterId}
      />
    );
  }

  if (isBunny) {
    return (
      <LionVideoPlyrBunny
        videoId={videoId}
        autoplay={autoplay}
        muted={muted}
        posterId={posterId}
      />
    );
  }

  if (isLyon) {
    return (
      <LionVideoPlyrLyon
        videoId={videoId}
        autoplay={autoplay}
        muted={muted}
        posterId={posterId}
      />
    );
  }

  return <LionVideoPlayerInvalid />;
});

interface IProps {
  posterId?: string;
  videoId?: string;
  title?: string;
  autoplay?: boolean;
  muted?: boolean;
}

export const LionVideoPlayer = memo(({
  posterId,
  videoId,
  title,
  autoplay,
  muted,
}: IProps) => {
  if (!videoId) {
    return <ContentPoster alt={title} src={ucarecdnScaleCropOptimize('1200x675', posterId)} />;
  }

  return (
    <LionVideoPlayerContent
      videoId={videoId}
      posterId={posterId}
      autoplay={autoplay}
      muted={muted}
    />
  );
});
